  class AgeGate extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.approveButton = this.querySelector('[data-handle-yes]');
      this.rejectButton = this.querySelector('[data-handle-no]');

      if (this.approveButton && this.rejectButton) {
        this.approveButton.addEventListener('click', this.handleYes.bind(this));
        this.rejectButton.addEventListener('click', this.handleNo.bind(this));
      }

      if (!this.checkAgeVerification()) {
        this.parentElement?.classList.remove('verification-container--visible');
      } else {
        this.parentElement?.classList.add('verification-container--visible');
      }
    }

    disconnectedCallback() {
      if (this.approveButton) {
        this.approveButton.removeEventListener('click', this.handleYes.bind(this));
      }
    
      if (this.rejectButton) {
        this.rejectButton.removeEventListener('click', this.handleNo.bind(this));
      }
    }

    checkAgeVerification() {
      const lastVerified = localStorage.getItem('ageVerified');
      const oneHour = 60 * 60 * 1000;

      if (lastVerified && Date.now() - parseInt(lastVerified) < oneHour) {
        return false;
      } else {
        return true;
      }
      
    }

    handleYes() {
      localStorage.setItem('ageVerified', Date.now().toString());
      this.parentElement?.classList.remove('verification-container--visible');
    }

    handleNo() {
      alert('You must be of legal age to access this site.');
      this.classList.remove('verification-container--visible');
      window.location.href = 'https://www.google.com';
    }
  }

  customElements.define('age-gate', AgeGate);